import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledSmall2 = makeDefaultTypographyStyled(
  'Small2',
  'small',
  0.69,
  1.2,
);
